var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckFilledWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 0.667969C3.95024 0.667969 0.666992 3.95121 0.666992 8.0013C0.666992 12.0514 3.95024 15.3346 8.00033 15.3346C12.0504 15.3346 15.3337 12.0514 15.3337 8.0013C15.3337 3.95121 12.0504 0.667969 8.00033 0.667969ZM11.4717 6.47271C11.7321 6.21236 11.7321 5.79025 11.4717 5.5299C11.2114 5.26955 10.7893 5.26955 10.5289 5.5299L7.00033 9.05849L5.47173 7.5299C5.21138 7.26955 4.78927 7.26955 4.52892 7.5299C4.26857 7.79025 4.26857 8.21236 4.52892 8.47271L6.52892 10.4727C6.78927 10.7331 7.21138 10.7331 7.47173 10.4727L11.4717 6.47271Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilledWhite);
export default __webpack_public_path__ + "static/media/check-filled-white.565160899727c140ae0ec88658058f5c.svg";
export { ForwardRef as ReactComponent };